import router from "@/router";
import { AxiosError } from "axios";
// import { router } from "expo-router";

export const errorInterceptor = (error: AxiosError) => {
  // console.error("ERROR", error);
  if (!error.response) {
    throw new Error("Erro de conexão");
  }

  const status = error.response.status;
  const data: any = error.response.data;

  if (status === 401) {
    // TODO: adaptar essa parada aqui
    router.push("/login");
    alert("Sessão expirada");
  }

  const message = extractErrorMessage(data, status);
  throw new Error(message);
};

export const extractErrorMessage = (data: any, status: number) => {
  if (data?.message) return data.message;
  if (data?.errors) {
    const firstError = Object.values(data.errors)[0];
    if (Array.isArray(firstError)) return firstError[0];
    return String(firstError);
  }
  return `Erro ${status} na requisição`;
};
